$(document).ready(function(){

	// -- Init --
	var $gridGallery = $('.gridGallery').isotope({
	  itemSelector: '.grid__item',
		filter: '*',
		layoutMode: 'masonry',
	  percentPosition: true,
	  masonry: {
	    columnWidth: '.grid__sizer',
	    gutter: 0
	  }
	});
	$gridGallery.imagesLoaded().progress(function() {
	  $gridGallery.isotope('layout');
	});


});